import { render } from "./accountAndSafe.vue?vue&type=template&id=7f8590a4&scoped=true"
import script from "./accountAndSafe.vue?vue&type=script&lang=js"
export * from "./accountAndSafe.vue?vue&type=script&lang=js"

import "./accountAndSafe.vue?vue&type=style&index=0&id=7f8590a4&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f8590a4"]])

export default __exports__